import React, { useState, useRef, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  CheckBox,
  StyledSubTitle,
  StyledContent,
  StyledLabel,
  OuterBox,
  OuterBoxContainer,
  ContentWrapper,
  SaveButtonWrapper,
  SaveButton,
  StyledSubtitle
} from './Styles';
import SettingsService from '../../services/SettingsService';
import Alert from '../../_shared/components/Alert';
import { httpCodes } from '../../_shared/constants/httpMethods';
import TRToast from '../../_shared/helpers/TRToast';

const AutoWinSettingOmp = ({ testId = 'AutoWinSettingOmp' }) => {
  const settingsService = SettingsService.get();

  const autoWinCheckBoxRef = useRef(null);

  const [autoWinEnabled, setAutoWinEnabled] = useState();

  useEffect(() => {
    settingsService.getAutoWinSetting().then(getAutoWinSettingResponse => {
      setAutoWinEnabled(getAutoWinSettingResponse);
    });
  }, [settingsService]);

  const handleSave = () => {
    const autoWinChecked = autoWinCheckBoxRef?.current?.checked;
    if (autoWinEnabled !== autoWinChecked)
      settingsService
        .updateAutoWinSetting(autoWinChecked)
        .then(updateAutoWinSettingResponse => {
          if (updateAutoWinSettingResponse.status === httpCodes.OK) {
            setAutoWinEnabled(autoWinChecked);
            const messageId = autoWinChecked
              ? 'autowin.setting.enabled'
              : 'autowin.setting.disabled';
            TRToast(
              <Alert
                variant="success"
                messages={[<FormattedMessage id={messageId} />]}
                isOmp
              />
            );
          }
        });
  };

  return (
    <OuterBoxContainer>
      <OuterBox>
        <ContentWrapper>
          <StyledSubTitle data-testid={`${testId}-autoWin`}>
            <FormattedMessage id="autowin.setting.auto.win" />
          </StyledSubTitle>
          <StyledContent data-testid={`${testId}-description`}>
            <FormattedMessage id="autowin.setting.description" />
          </StyledContent>
          <StyledSubtitle data-testid={`${testId}-subTitle`}>
            <FormattedMessage id="autowin.settings.how.it.works" />
          </StyledSubtitle>
          <StyledContent data-testid={`${testId}-floorPrice`}>
            <FormattedMessage id="autowin.setting.unmet.floor.price.ends.rebrand" />
          </StyledContent>
          <StyledContent>
            <FormattedMessage id="autowin.setting.or" />
          </StyledContent>
          <StyledContent data-testid={`${testId}-negotiation`}>
            <FormattedMessage id="autowin.setting.seller.first.offer.rebrand" />
          </StyledContent>
          <StyledLabel>
            <CheckBox
              defaultChecked={autoWinEnabled}
              data-testid={`${testId}-checkbox`}
              ref={autoWinCheckBoxRef}
            />
            <FormattedMessage id="autowin.setting.enable.auto.win" />
          </StyledLabel>
          <SaveButtonWrapper>
            <SaveButton
              data-testid={`${testId}-saveButton`}
              onClick={handleSave}
            >
              <FormattedMessage
                id="autowin.setting.save"
                data-testid={`${testId}-save`}
              />
            </SaveButton>
          </SaveButtonWrapper>
        </ContentWrapper>
      </OuterBox>
    </OuterBoxContainer>
  );
};

export default AutoWinSettingOmp;
